import React from 'react';
import {
    Grid2,
    Card,
    CardContent,
    Typography,
    Paper,
    Box,
} from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { getRandomColor } from '../../utils/randomColor';
import { useTranslation } from 'react-i18next';

function SalesDashboard({ dashboard }) {

    const { t } = useTranslation();

    if (!dashboard.topPlatforms) { return }

    const totalSalesAmount = dashboard.totalSalesAmount.toFixed(0)
    const totalExpensesAmount = 0 //dashboard.totalExpensesAmount.toFixed(2) ?? 0
    const totalExpensesWithAds = dashboard.totalSpendWithGoogleAds?.spend ?? 0
    const totalProfit = (totalSalesAmount - totalExpensesAmount).toFixed(0)
    const topPlatformName = dashboard.topPlatforms[0]?.platformName ?? 'N/A'
    const roas = (totalExpensesWithAds / totalSalesAmount).toFixed(2)

    console.log("totalExpensesWithAds", totalExpensesWithAds)
    console.log("totalSalesAmount", totalSalesAmount)
    //const roi = totalExpensesAmount == 0 ? "0.00" : (totalExpensesAmount / totalSalesAmount).toFixed(2)

    const pieChartData = dashboard.topPlatforms.map((item) => {
        return {
            id: item.platformName,
            label: item.platformName,
            value: item.totalAmount,
            color: getRandomColor(),
        }
    });

    return (
        <Paper 
            elevation={0}
            sx={{ 
                padding: 2,
                backgroundColor: '#F8F9FA', 
                minWidth: '70%',
                height: '100%'
            }}>
            <Box sx={{ 
                    padding: 2, 
                    display: { sm: 'block', md: 'flex' },
                }}>
                {/* Dashboard Metrics */}
                <Grid2 
                    container 
                    spacing={2} 
                    mb={6} 
                    width={{
                        xs: '100%',   // Full width on mobile
                        sm: '75%',    // Slightly reduced on small screens
                        md: '50%',    // Default at medium screens
                        lg: '40%',    // Even smaller on large screens
                      }}
                >
                {[
                    { title: t('salesDashboard.totalConverted'), value: `${totalSalesAmount}`, currency: "$" },
                    { title: t('salesDashboard.profit'), value: `${totalProfit}`, currency: "$" },
                    { title: t('salesDashboard.topPlatform'), value: topPlatformName },
                    { title: t('salesDashboard.totalSales'), value: dashboard.totalSalesCount },
                    { title: t('salesDashboard.platforms'), value: dashboard.topPlatforms.length },
                    { title: t('salesDashboard.clicks'), value: dashboard.totalClicks || 0 },
                    { title: 'ROAS', value: roas },
                    ].map((metric, index) => (
                        <Grid2 xs={12} sm={12} md={4} key={index}>
                            <Card sx={{ 
                                    height: '200px', 
                                    width: { xs: '80vw', sm: '90vw', md: '200px' }, 
                                    borderRadius: 1, 
                                    boxShadow: "none",
                                }}>
                                <CardContent>
                                    <Typography 
                                        variant="body" 
                                        sx={{ 
                                            color: 'gray',
                                            fontSize: "14px"
                                        }}>
                                        {metric.title}
                                    </Typography>
                                    <Box sx={{
                                        width: '100%',
                                        height: '130px',
                                        textAlign: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                    <Typography 
                                        variant="h6"
                                        sx={{ marginBottom: 1, marginRight: 0.5 }}
                                    >
                                        {metric.currency}
                                    </Typography>
                                    <Typography
                                    sx={{
                                        fontSize: '40px',   
                                        fontWeight: 'bold',
                                        color: 'rgb(50, 50, 50)'
                                    }}>
                                        {metric.value}
                                    </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid2>
                    ))}
                </Grid2>

                {/* Sparkline Chart */}
                <Box 
                    sx={{ 
                        mt: 4,
                        display: { xs: 'none', md: 'block' },
                    }}
                >
                    <PieChart 
                        series={[{
                            data: pieChartData,
                            type: 'pie',
                        }]} 
                        width={600} 
                        height={400} 
                    />
                </Box>
            </Box>
        </Paper>
    );
}

export default SalesDashboard;